<template>
    <modal
        v-if="open"
        root-id="trialWelcomeModal"
        root-classes="modal show"
        modal-width="modal-xl"
        :ignore-escape="true"
    >
        <template #modal-close>
            <div class="modal-close-container">
                <button type="button" class="modal-close modal-close-white" data-miss="#trialWelcomeModal" @click="closeModal">
                    <svg
                        width="25"
                        xmlns="http://www.w3.org/2000/svg"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 24 24"
                        role="img"
                        aria-label="Icono para cerrar mensaje"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
            </div>
        </template>

        <template #modal-container>
            <div class="relative -mx-6 -mt-10 h-67 lg:-mx-10 md:-mt-6">
                <img src="/images/modal-trial.png" alt="Círculo Plus" class="object-cover w-full h-full sm:rounded-t-lg">
            </div>
            <div class="sm:w-4/5 mx-auto mt-5">
                <h1 class="text-xl md:text-2xl font-semibold leading-tight text-center">Más beneficios, más recompensas: ¡Descubre las ventajas y beneficios de <span class="inline-block text-2xl md:text-3xl text-red-500">Círculo Plus este 2025!</span></h1>
            </div>

            <!-- Mostrar modal #trialPlansModal al dar click en botón -->
            <div class="flex justify-center mt-3">
                <a href="#" @click.prevent="nextStep" class="block w-full px-8 py-3 btn btn-blue md:inline-block md:w-auto">Quiero saber más</a>
            </div>
            <p class="text-center leading-tight mt-5">Prueba <strong>GRATIS de 15 días</strong> y disfruta de promociones exclusivas, boletos gratis y más.</p>
        </template>
    </modal>
</template>
<script>
import Modal from './Modal';
import Form from '../support/Form';

export default {
    components: {
        Modal,
    },

    data() {
        return {
            open: true,
            form: new Form({
                user_is_interested: false,
            }),
        };
    },

    methods: {
        closeModal() {
            $('body, html').removeClass('overflow-hidden');

            this.open = false;
        },

        nextStep() {
            this.form.user_is_interested = true;

            this.form.post('/suscripcion/plan').then((response) =>
                this.$emit('userInterested')
            )
        },
    },
};
</script>
